<template>
  <section class="dept-reviews dept-modern__section">
    <div class="dept-modern">
      <div class="dept-reviews__head">
        <h2 v-if="heading" class="dept-reviews__title">{{ heading }}</h2>
        <router-link
          v-if="allLink"
          :to="allLink"
          class="dept-reviews__all"
        >{{ allText || 'Все отзывы' }}</router-link>
      </div>

      <p v-if="loading" class="dept-reviews__empty">Загрузка отзывов…</p>
      <p v-else-if="!items.length" class="dept-reviews__empty">
        Отзывов по выбранным подразделениям и отделениям пока нет.
      </p>

      <div v-else class="dept-reviews__grid">
        <ReviewsCard
          v-for="item in items"
          :key="item.id"
          :item="item"
          :preview-length="160"
        />
      </div>
    </div>
  </section>
</template>

<script>
import reviewsApi from '@/api/reviews'
import ReviewsCard from '@/components/Reviews/ReviewsCard.vue'

export default {
  name: 'DepartmentReviews',
  components: { ReviewsCard },
  props: {
    heading: { type: String, default: 'Отзывы' },
    departmentIds: { type: Array, default: () => [] },
    medicalDepartmentIds: { type: Array, default: () => [] },
    limit: { type: Number, default: 6 },
    allReviewsText: { type: String, default: 'Все отзывы' },
    allReviewsLink: { type: String, default: '/about/reviews' },
  },
  data() {
    return {
      items: [],
      loading: false,
    }
  },
  computed: {
    allText() {
      return this.allReviewsText
    },
    allLink() {
      const ids = (this.departmentIds || []).filter(Boolean)
      const medIds = (this.medicalDepartmentIds || []).filter(Boolean)
      if (ids.length === 1 && medIds.length === 0) {
        return {
          path: '/about/reviews',
          query: { departmentId: ids[0] },
        }
      }
      if (medIds.length === 1 && ids.length === 0) {
        return {
          path: '/about/reviews',
          query: { medicalDepartmentId: medIds[0] },
        }
      }
      return this.allReviewsLink || '/about/reviews'
    },
  },
  watch: {
    departmentIds: {
      handler() {
        this.fetchReviews()
      },
      deep: true,
    },
    medicalDepartmentIds: {
      handler() {
        this.fetchReviews()
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchReviews()
  },
  methods: {
    unwrapList(response) {
      const data = response && response.data
      if (Array.isArray(data)) return data
      if (data && Array.isArray(data.result)) return data.result
      return []
    },
    async fetchReviews() {
      const ids = (this.departmentIds || []).filter(Boolean)
      const medIds = (this.medicalDepartmentIds || []).filter(Boolean)
      if (!ids.length && !medIds.length) {
        this.items = []
        return
      }
      this.loading = true
      try {
        const params = {}
        if (ids.length) params.departmentIds = ids.join(',')
        if (medIds.length) params.medicalDepartmentIds = medIds.join(',')
        const response = await reviewsApi.getReviews(params)
        const list = this.unwrapList(response)
        this.items = list.slice(0, this.limit || 6)
      } catch (e) {
        console.warn(e)
        this.items = []
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
$green: #336633;

.dept-reviews__head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.dept-reviews__title {
  margin: 0;
  font-family: "TTDrugs", sans-serif;
  font-size: 26px;
  font-weight: 700;
  color: $green;
}

.dept-reviews__all {
  font-family: "Circe", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: $green;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.dept-reviews__empty {
  margin: 0;
  font-family: "Circe", sans-serif;
  font-size: 15px;
  color: #6b7280;
}

.dept-reviews__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 767.98px) {
    grid-template-columns: 1fr;
  }
}
</style>
